<mat-form-field appearance="outline" class="w-100">
  <mat-label>Select an Event</mat-label>
  <mat-select (valueChange)="update($event)" [value]="ngModel">
    <mat-option *ngFor="let event of $events | async" [value]="event.id">{{ event.title }}</mat-option>
  </mat-select>
</mat-form-field>
